var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-menu",class:{ open: _vm.open },on:{"click":_vm.handleMobileMenu}},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }